// extracted by mini-css-extract-plugin
export default {"link":"PatientTable_link__u4UwZ"};